import { forwardRef, HTMLAttributes } from 'react'
import { Slot } from '@radix-ui/react-slot'
import { omit } from 'lodash'

import { cn } from '@/lib/utils'

export type SectionProps = HTMLAttributes<HTMLDivElement> & {
  asChild?: boolean
  theme?: 'light' | 'dark' | string
}

const Section = forwardRef<HTMLDivElement, SectionProps>(
  ({ asChild, className, theme = 'light', ...props }, ref) => {
    const Component = asChild ? Slot : 'section'

    return (
      <Component
        ref={ref}
        className={cn({ dark: theme === 'dark' }, className)}
        {...omit(props, [
          'theme',
          'page_background',
          'acfe_flexible_layout_title',
          'acfe_flexible_layout_toggle'
        ])}
      />
    )
  }
)

export default Section
